export * from './post-konstante-request.interface';
export * from './post-konstante-response.interface';
export * from './post-konstante.shapes';
